import _ from 'lodash';
import { IconTruckDelivery, IconTruckLoading } from '@tabler/icons-react';
import { green, yellow } from '@mui/material/colors';

export const OperationTypes = [
  {
    id: 'PICKUP YACHT',
    label: 'PICKUP YACHT',
    color: '#fff',
    backgroundColor: green[500],
    icon: <IconTruckLoading width={16} height={16} color='#fff' />,
    width: 170,
  },
  {
    id: 'PICKUP SUPPLIER',
    label: 'PICKUP SUPPLIER',
    backgroundColor: yellow[500],
    icon: <IconTruckLoading width={16} height={16} />,
    width: 170,
  },
  {
    id: 'DELIVERY YACHT',
    label: 'DELIVERY YACHT',
    color: '#fff',
    backgroundColor: green[500],
    icon: <IconTruckDelivery width={16} height={16} color='#fff' />,
    width: 170,
  },
  {
    id: 'DELIVERY SUPPLIER',
    label: 'DELIVERY SUPPLIER',
    backgroundColor: yellow[500],
    icon: <IconTruckDelivery width={16} height={16} />,
    width: 170,
  },
];
export const Department = [
  {
    label: 'PROVISIONS',
    id: 'PROVISIONS',
  },
  {
    label: 'INTERIORS',
    id: 'INTERIORS',
  },
];

export const Status = [
  {
    id: 'None',
    label: 'None',
  },
  {
    id: 'OPEN',
    label: 'OPEN',
  },
  {
    id: 'CLOSED',
    label: 'CLOSED',
  },
];

export const DataConf = {
  initialState: {
    loading: false,
    error: null,
    data: [],
    meta: null,
  },
};

export const StatusRequest = [
  {
    id: 'None',
    label: 'None',
  },
  {
    id: 'OPEN',
    label: 'OPEN',
  },
  {
    id: 'CLOSED',
    label: 'CLOSED',
  },
];

export const StatusLogbookDefault = [
  {
    id: 'NEW REQUEST',
    label: 'NEW REQUEST',
    color: '#fff',
    backgroundColor: '#005488',
  },
  {
    id: 'CANCELLED',
    label: 'CANCELLED',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
];

export const StatusLogbookDeliveries = [
  {
    id: 'NEW REQUEST',
    label: 'NEW REQUEST',
    color: '#fff',
    backgroundColor: '#005488',
  },
  {
    id: 'STAND-BY',
    label: 'STAND-BY',
    color: '#fff',
    backgroundColor: '#005488',
  },
  {
    id: 'SCHEDULED',
    label: 'SCHEDULED',
    color: '#fff',
    backgroundColor: '#ff6500',
  },
  {
    id: 'IN PROGRESS',
    label: 'IN PROGRESS',
    color: '#fff',
    backgroundColor: '#f6ca00',
  },
  {
    id: 'DELIVERED',
    label: 'DELIVERED',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'PICKED UP',
    label: 'PICKED UP',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'DECLINED',
    label: 'DECLINED',
    color: '#fff',
    backgroundColor: '#e74c3c',
  },
  {
    id: 'CANCELLED',
    label: 'CANCELLED',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
  {
    id: 'IN STOCK',
    label: 'IN STOCK',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'NO DRIVER',
    label: 'NO DRIVER',
    color: '#fff',
    backgroundColor: '#565656',
  },
];

export const StatusPriority = [
  {
    id: 'LOW',
    label: 'LOW',
  },
  {
    id: 'MEDIUM',
    label: 'MEDIUM',
  },
  {
    id: 'HIGH',
    label: 'HIGH',
  },
];
export const StatusTime = [
  {
    id: 'INDICATIVE',
    label: 'INDICATIVE',
  },
  {
    id: 'SPECIFIC',
    label: 'SPECIFIC',
  },
];

export const StatusLogbook = _.concat(
  _.map(StatusLogbookDefault, (item) => {
    return _.mapKeys(item, (value, key) => {
      switch (key) {
        case 'backgroundColor':
          return 'hex';
        case 'color':
          return 'textHex';
        default:
          return key;
      }
    });
  }),
  _.map(StatusLogbookDeliveries, (item) => {
    return _.mapKeys(item, (value, key) => {
      switch (key) {
        case 'backgroundColor':
          return 'hex';
        case 'color':
          return 'textHex';
        default:
          return key;
      }
    });
  })
);

export const OPTIONS_STATUS_LOGBOOK = {
  DEFAULT: StatusLogbookDefault,
  DELIVERIES: StatusLogbookDeliveries,
  SHIPPING: StatusLogbookDeliveries
}

export const PERMISSION_DRIVER_EDIT = ['DELIVERIES']


export const AreaOptions = [
  {
    id: null,
    label: 'NONE'
  },
  {
    id: 'NORD',
    label: 'NORTH'
  },
  {
    id: 'SUD',
    label: 'SOUTH'
  },
  {
    id: 'CARIBBEAN',
    label: 'CARIBBEAN'
  },
];

export const DefaultAreas = AreaOptions?.filter(
  (item) =>
    item?.id === null ||
    item?.id === 'NORD' ||
    item?.id === 'SUD'
);

export const DefaultStatusLogbook = StatusLogbookDeliveries?.filter(
  (item) =>
    item?.id === 'NEW REQUEST' ||
    item?.id === 'STAND-BY'
);